module.exports = __webpack_public_path__ + "media/svg/top-4a83512f.svg";